import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./assets/fonts/ROBO.otf";
import "./i18n";
import "./style/output.css";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "../src/components/ui/theme-provider";
const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <BrowserRouter>
    <ThemeProvider
      attribute="class"
      defaultTheme="light"
      enableSystem
      disableTransitionOnChange
    >
      <App />
    </ThemeProvider>
  </BrowserRouter>
);
